// extracted by css-extract-rspack-plugin
export default {"InsightsFilterBarContainer":"InsightsFilterBar-module__InsightsFilterBarContainer__OJUzDZY"};